var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarget1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5833 39.75V6.41667C35.5833 5.3116 35.1443 4.25179 34.3629 3.47039C33.5815 2.68899 32.5217 2.25 31.4167 2.25H10.5833C9.47826 2.25 8.41846 2.68899 7.63705 3.47039C6.85565 4.25179 6.41667 5.3116 6.41667 6.41667V39.75M35.5833 39.75H39.75M35.5833 39.75H25.1667M6.41667 39.75H2.25M6.41667 39.75H16.8333M25.1667 39.75V29.3333C25.1667 28.7808 24.9472 28.2509 24.5565 27.8602C24.1658 27.4695 23.6359 27.25 23.0833 27.25H18.9167C18.3641 27.25 17.8342 27.4695 17.4435 27.8602C17.0528 28.2509 16.8333 28.7808 16.8333 29.3333V39.75M25.1667 39.75H16.8333M14.75 10.5833H16.8333M14.75 18.9167H16.8333M25.1667 10.5833H27.25M25.1667 18.9167H27.25",
    stroke: "url(#paint0_linear_317_74)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_74",
    x1: 2.25,
    y1: 21.0007,
    x2: 39.7485,
    y2: 21.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0093FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget1);
export default __webpack_public_path__ + "static/media/target1.5226110711d24c0e297afcd4a614f2e3.svg";
export { ForwardRef as ReactComponent };